import { Controller } from "@hotwired/stimulus"
import { formatDate, formatPln, getAllJSON, getJSON } from "../api.js"

// Portfel organizacji: split salda (wpłacone brutto / bonus netto / razem brutto),
// i historia środków z kieszenią. Doładowanie obsługuje komponent package-picker
// (po opłaceniu od razu wysyła zdarzenie package-picker:paid → load()).
export default class extends Controller {
  static targets = [
    "rows", "status",
    "deposited", "bonus", "total",
  ]
  static values = {
    url: String,       // /api/credits/
    walletUrl: String, // /api/wallet/balance/
  }

  static POCKET_LABEL = { deposited: "Wpłacone", bonus: "Bonus" }

  connect() { this.load() }

  async load() {
    let list
    let wallet
    try {
      ;[list, wallet] = await Promise.all([
        getAllJSON(this.urlValue),
        getJSON(this.walletUrlValue),
      ])
    } catch {
      this.#status("Nie udało się załadować portfela. Odśwież stronę.")
      return
    }
    if (this.hasDepositedTarget) this.depositedTarget.textContent = formatPln(wallet.deposited_pln)
    if (this.hasBonusTarget) this.bonusTarget.textContent = formatPln(wallet.bonus_pln)
    if (this.hasTotalTarget) this.totalTarget.textContent = formatPln(wallet.total_available_gross_pln)

    const credits = list
    this.rowsTarget.textContent = ""
    if (!credits.length) {
      this.#status("Brak środków w historii.")
      return
    }
    this.#status(null)
    const template = document.getElementById("credit-row-template")
    for (const credit of credits) {
      const row = template.content.firstElementChild.cloneNode(true)
      row.querySelector('[data-field="pocket"]').textContent =
        this.constructor.POCKET_LABEL[credit.pocket] ?? credit.pocket
      row.querySelector('[data-field="amount"]').textContent = formatPln(credit.amount_pln)
      const noteEl = row.querySelector('[data-field="note"]')
      // a clawed-back bonus has amount_used == amount; say it was revoked, not that it was spent
      const noteText = credit.revoked_at ? [credit.note, "cofnięty przy zwrocie"].filter(Boolean).join(" · ") : credit.note
      noteEl.textContent = noteText || "—"
      noteEl.toggleAttribute("data-empty", !noteText) // phone ledger hides empty meta (CSS [data-empty])
      const complaintEl = row.querySelector('[data-field="complaint"]')
      complaintEl.textContent = credit.complaint ? `reklamacja #${credit.complaint}` : "—"
      complaintEl.toggleAttribute("data-empty", !credit.complaint)
      row.querySelector('[data-field="created"]').textContent = formatDate(credit.created)
      this.rowsTarget.appendChild(row)
    }
  }

  // --- prywatne ---

  #status(message) {
    if (!this.hasStatusTarget) return
    this.statusTarget.hidden = message === null
    if (message !== null) this.statusTarget.textContent = message
  }
}
